export default __webpack_public_path__ + "static/media/play-rating.c6493264.webp";